var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('LevellingView',{attrs:{"evaluation":_vm.isEvaluation},on:{"openDocument":_vm.openDocument,"setLevel":_vm.setLevel,"editLevel":_vm.editLevel}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }